import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Alert } from '@gsa/afp-component-library';
import { useMutation } from '@apollo/client';
import AttachmentModal from '../../../../components/Attachment/AttachmentModal';
import { DELETE_DOCUMENT_FROM_BIDLINE } from '../provider/queries';
import { useBidLineDetails } from '../provider/bid-line-details-provider';
import { pageErrorMessage } from '../../../../utilities/error-handling';

const DeleteDocModal = ({ doc, onSuccess, onCancel }) => {
  const { isAdmin } = useBidLineDetails();
  const [error, setError] = useState(null);
  const [deleteDoc, { loading }] = useMutation(DELETE_DOCUMENT_FROM_BIDLINE, {
    onCompleted: (res) => {
      if (res?.deleteBidLineAttachment === true) {
        onSuccess();
      }
      if (res?.deleteBidLineAttachment?.errors) {
        setError(res.deleteBidLineAttachment.errors[0]?.message);
      }
    },
    onError: (error) => {
      setError(
        pageErrorMessage(
          error,
          'Unexpected error occurred. Please try again later.',
        ),
      );
    },
  });

  const onDelete = () => {
    if (isAdmin) return; // skip API call for site admin, CS, CO, engineer
    deleteDoc({
      variables: {
        bidLineAttachmentId: parseInt(doc.bidLineAttachmentId, 10),
      },
    });
  };

  return (
    <AttachmentModal
      id="bidlibe-attachment-delete-confirm-modal"
      title="Delete confirmation"
      show
      onClose={onCancel}
      variant="large"
      actions={
        <>
          <Button
            type="button"
            variant="unstyled"
            onClick={onCancel}
            disabled={loading}
            label="Cancel"
          />
          <Button
            disabled={loading}
            variant="secondary"
            onClick={onDelete}
            label="Delete"
          />
        </>
      }
    >
      {error && <Alert type="error">{error}</Alert>}
      <p>
        Are you sure you want to remove <strong>{doc.name}</strong> from the
        bid?
      </p>
    </AttachmentModal>
  );
};

DeleteDocModal.propTypes = {
  doc: PropTypes.shape({
    bidLineAttachmentId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

DeleteDocModal.defaultProps = {};

export default DeleteDocModal;
